
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { Row, Col, Container, Button, Table } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ApiService from 'services';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { getOvers, getDrr } from 'utils/points';
import { getIdFromSlug } from 'utils/misc';
import ScoreCardView from 'components/scorecard';
import LoadingBar from 'components/LoadingBar';
import MatchList from 'components/matchlist';
import { getTeamLink } from 'utils/links';
import TCABreadCrumb from 'components/breadcrumb';

const tournamentMenuOptions = [

    {
        "title": "Schedule",
        "link": "schedule"
    },
    {
        "title": "Scores",
        "link": "scores"
    },
    {
        "title": "Points Table",
        "link": "points"
    },
];






export default function TournamentDetails(props) {

    const { tournamentSlug } = useParams();
    const [tournamentId, setTournamentId] = useState("");

 
 

    const [tourName, setTourName] = useState({});
    const [tabContent, setTabContent] = useState({
        schedule: {},
        scores: {},
        points: {}
    });

    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('schedule');
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    // Function to update the content of a specific tab
    const updateTabContent = (tabKey, newContent) => {
        setTabContent(prevContent => ({
            ...prevContent,
            [tabKey]: newContent
        }));
    };
    useEffect(() => {
        setTournamentId(getIdFromSlug(tournamentSlug));
    }, [tournamentSlug]);

    useEffect(() => {
        const fetchData = async (type) => {
            try {
                setLoading(true);
                let response;
                switch (type) {
                    case 'schedule':
                        response = await ApiService.getBriefSchedule(tournamentId);

                        response.Matches.sort(function (a, b) {
                            var dateDiff = (new Date(a.MatchDate2)) - (new Date(b.MatchDate2));
                            return (dateDiff === 0)
                                ? (a.Groupname > b.Groupname) ? 1 : -1
                                : dateDiff;
                        });
                        updateTabContent('schedule', response);
                        setLoading(false);
                        break;
                    case 'scores':
                        response = await ApiService.getScores(tournamentId);

                        let allScores = [];
                        for (var j = 0; j < response.Scores.length; j++) {
                            allScores = allScores.concat(response.Scores[j]);
                        }
                        allScores.sort(function (a, b) { return a.MatchId < b.MatchId ? 1 : -1; });
                        updateTabContent('scores', allScores);
                        setLoading(false);
                        break;
                    case 'points':
                        response = await ApiService.getFullPointsTable(tournamentId);

                        updateTabContent('points', response);
                        setTourName(response.PointTable[0].TournamentName)
                        setLoading(false);
                        break;
                }
                //console.log(response);
               
            } catch (error) {
                // Handle error
                //
                console.log(error);
                setLoading(false);
            }
        };
        if (tournamentId) {
            fetchData('schedule');
            fetchData('scores');
            fetchData('points');
        }

    }, [tournamentId]);

    const handleCloseOffcanvas = () => {
        setShowOffcanvas(false);
        // Additional logic for when offcanvas is closed
        console.log('Offcanvas closed');
    };

    const getTournamentMenu = () => {
        return <Tabs
            defaultActiveKey="schedule"
            id="uncontrolled-tab-example"
            className="mt-3 score-tabs"
            fill
            onSelect={handleTabSelect}
        >
            {tournamentMenuOptions.map((oneOption, index) => {
                return <Tab eventKey={oneOption.link} key={index} title={oneOption.title}>
                    <div>
                        {oneOption.link === 'points' && getUIForPointTable()}
                        {oneOption.link === 'scores' && getUIForScoreTable()}
                        {oneOption.link === 'schedule' && getUIForSchedule()}
                    </div>
                </Tab>
            })}

        </Tabs>
    }
    const getUIForPointTable = () => {

        {/* UI for Points Table */ }
        return <div style={{ width: '100%' }}>
            <Table size="sm" className='mt-3 d-none d-md-block' bordered striped hover>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Team</th>
                        <th title='Played'>P</th>
                        <th title='Won'>W</th>
                        <th title='Tie'>T</th>
                        <th title='Lost'>L</th>
                        <th title='Abandoned'>A</th>
                        <th title='Bonus Points'>B</th>
                        <th >For Runs</th>
                        <th >Opp Runs</th>
                        <th >For Overs</th>
                        <th >Opp Overs</th>
                        <th >For Run Rate</th>
                        <th >Opp Run Rate</th>
                        <th>NRR</th>
                        <th title='Total Points'>Points</th>
                    </tr>
                </thead>
                <tbody>

                    {tabContent['points'] && tabContent['points'].PointTable && tabContent['points'].PointTable.map((oneRow, index) => {

                        let forOvers = getOvers(oneRow.Over);
                        let oppOvers = getOvers(oneRow.Opp_Over);
                        let forDrr = getDrr(oneRow.Score, forOvers);
                        let oppDrr = getDrr(oneRow.Opp_Score, oppOvers);
                        return (
                            <tr key={index}>
                                <td>{(index + 1)}</td>
                                <td><a href={'teams?v=teams&t=' + oneRow.TeamId}>{oneRow.TeamName}</a></td>
                                <td>{oneRow.Played}</td>
                                <td>{oneRow.Win}</td>
                                <td>{oneRow.Tie}</td>
                                <td>{oneRow.Loss}</td>
                                <td>{oneRow.Ab}</td>
                                <td>{oneRow.Bonus}</td>
                                <td>{oneRow.Score}</td>
                                <td>{oneRow.Opp_Score}</td>
                                <td>{forOvers}</td>
                                <td>{oppOvers}</td>
                                <td>{forDrr.toFixed(3)}</td>
                                <td>{oppDrr.toFixed(3)}</td>
                                <td>{(forDrr - oppDrr).toFixed(3)}</td>
                                <td>{oneRow.TotalPoints}</td>
                            </tr>
                        )
                    })}

                </tbody >

            </Table>
            <Table responsive className='mt-3 d-md-none'>

                <thead>
                    <tr>
                        <th>#</th>
                        <th>Team</th>
                        <th title='Played'>P</th>
                        <th title='Won'>W</th>
                        <th title='Tie'>T</th>
                        <th title='Lost'>L</th>
                        <th title='Abandoned'>A</th>
                        <th title='Bonus Points'>B</th>
                        <th>NRR</th>
                        <th title='Total Points'>Points</th>
                    </tr>
                </thead>
                <tbody>
                    {tabContent['points'] && tabContent['points'].PointTable && tabContent['points'].PointTable.map((oneRow, index) => {

                        let forOvers = getOvers(oneRow.Over);
                        let oppOvers = getOvers(oneRow.Opp_Over);
                        let forDrr = getDrr(oneRow.Score, forOvers);
                        let oppDrr = getDrr(oneRow.Opp_Score, oppOvers);

                        return <tr key={index}>
                             <td>{(index + 1)}</td>
                            <td>
                                {getTeamLink(oneRow.TeamName, oneRow.TeamId)}
                            </td>
                            <td>{oneRow.Played}</td>
                            <td>{oneRow.Win}</td>
                            <td >{oneRow.Tie}</td>
                            <td >{oneRow.Loss}</td>
                            <td>{oneRow.Ab}</td>
                            <td>{oneRow.Bonus}</td>
                            <td>{(forDrr - oppDrr).toFixed(3)}</td>
                            <td>{oneRow.TotalPoints}</td>
                        </tr>
                    })}
                </tbody>
            </Table>
        </div>
    };
    const getUIForSchedule = () => {

        // Get the current date
        const currentDate = new Date();

        // Split matches into upcoming and past matches
        const upcomingMatches = tabContent['schedule']?.Matches
            ?.flat()
            .filter((oneMatch) => new Date(oneMatch.MatchDate2) > currentDate);

        const pastMatches = tabContent['schedule']?.Matches
            ?.flat()
            .filter((oneMatch) => new Date(oneMatch.MatchDate2) <= currentDate);
        return (<>
            <MatchList matches={upcomingMatches} label={"Upcoming Matches"} />
            <MatchList matches={pastMatches} label={"Past Matches"} />
        </>
        )
    };
    const getUIForScoreTable = () => {
        return <Table responsive size="sm" striped bordered hover>
            <thead>
                <tr>
                    <th >Scores</th>
                </tr>
            </thead>
            <tbody>

                {tabContent['scores'] && tabContent['scores'].length > 0 && tabContent['scores'].map((oneMatchScore, index) => {

                    return (
                        <tr key={index}>
                            <td>
                                <ScoreCardView matchData={oneMatchScore} />
                            </td>
                        </tr>
                    )

                })}

            </tbody>
        </Table>

    };
    const getTournamentMenuMobile = (teamName) => {

        return <Navbar collapseOnSelect expand="lg" expanded={showOffcanvas}>
            <Container>

                <Button
                    variant="secondary"
                    onClick={() => setShowOffcanvas(true)}
                    aria-controls="responsive-navbar-nav"
                >
                    Team Menu
                </Button>

                <Navbar.Offcanvas
                    id='responsive-navbar-nav'
                    aria-labelledby='offcanvasNavbarLabel-expand-sm'
                    placement="end"
                    show={showOffcanvas} onHide={handleCloseOffcanvas}
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id='offcanvasNavbarLabel-expand-sm'>
                            {teamName}
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav
                            className="me-auto my-2 my-lg-0"
                            style={{ maxHeight: '100px' }}
                        >
                            {tournamentMenuOptions.map((section, index) => (
                                section.hasChild ? <DropDownMenu key={index} linkTitle={section.title} childList={section.childList} /> : <Nav.Link key={index} href={section.url}>{section.title}</Nav.Link>
                            ))}
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container>
        </Navbar>
    }
    const handleTabSelect = (selectedTab) => {
        setActiveTab(selectedTab);
        // Do something with the selected tab
        console.log('Selected Tab:', selectedTab);
    };

     
    const breadCrumbData = [
        {
            title: "All Tournaments",
            link: "/tournaments"
        },
        {
            title: tourName + ' Tournament'
        }
    ];

    if (loading) {
        return <LoadingBar show={loading} />
    }
    else {
        return (
            <>
              <Row>
                <Col>
                    <TCABreadCrumb breadCrumbData={breadCrumbData} />
                    <h1 className='text-center'> {tourName} Tournament</h1>
                </Col>
            </Row>
               
                <Row>
                    <Col>
                        <div className=''>
                            {getTournamentMenu()}
                        </div>
                        {/*
                        <div className='d-md-none'>
                            {getTournamentMenuMobile(data.TeamName)}
                        </div>
        */}
                    </Col>
                </Row>

            </>
        )
    }
}